import React from 'react';

import { Card, Link, TableRow } from '@ergeon/core-components';

const HomePage = () => {
  const wikis = [
    { name: 'Public', url: process.env.PUBLIC_WIKI_URL },
    { name: 'Private', url: process.env.PRIVATE_WIKI_URL },
  ];

  return (
    <div className="mx-auto flex w-full max-w-3xl flex-col gap-6 px-4 py-8 md:px-8 md:py-10">
      <h1 className="heading-3 text-gray-900 dark:text-white">Home</h1>
      <Card className="flex-col overflow-hidden" rounded="medium">
        {wikis.map(({ name, url }, index) => (
          <TableRow
            content={<Link className="break-all" href={url}>{url}</Link>}
            index={index}
            key={name}
            label={name} />
        ))}
      </Card>
    </div>
  );
};

export default HomePage;
